const spineSides = [
  {
    label: "Anterior",
    value: "Anterior",
    color: "#026b01",
  },
  {
    label: "Posterior",
    value: "Posterior",
    color: "#938e3d",
  },
];

export default spineSides;
